@let version = ticketingVersion();
@let details = ticketDetails();

@if (details && version) {
  <rs-web-ticket-details-header
    class="offcanvas-header"
    [deleteButton]="hasDeleteButton()"
    [title]="details | ticketTitle: version"
    [state]="details | ticketStatus: version"
    [externalId]="details?.externalId"
    (closeEvent)="!chatOpen() ? onClose() : chatOpen.set(false)"
    (cancelTicketEvent)="onCancelTicket()"
  ></rs-web-ticket-details-header>

  @if (!chatOpen()) {
    <div class="offcanvas-body">
      @if (version === 'METADATA') {
        <rs-web-ticket-details-overview-metadata [ticketDetails]="$any(details)" />
      } @else {
        <rs-web-ticket-details-overview-hq [ticketDetails]="$any(details)" />
      }
      @if (messengerEnabled()) {
        <rs-web-ticket-details-chat-overview
          [messageCount]="details.unreadMessages"
          [hideNewMessageCounter]="hideNewMessageCounter"
          (openChat)="openChat()"
        />
      }
    </div>
  } @else {
    <rs-web-ticket-details-chat
      [loading]="ticketChatActionState().pending"
      [sending]="newMessageActionState().pending"
      [ticketState]="details | ticketStatus: version"
      [ticketChat]="ticketChat()"
      [isReadOnly]="messagesReadOnly()"
      (sendMessage)="sendMessage($event)"
      (retryMessage)="retryMessage($event)"
      (refreshChat)="loadTicketChatDetails()"
    />
  }
}
